import { render, staticRenderFns } from "./DeliveryFeeList.vue?vue&type=template&id=6840b6df&scoped=true&"
import script from "./DeliveryFeeList.vue?vue&type=script&lang=js&"
export * from "./DeliveryFeeList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryFeeList.vue?vue&type=style&index=0&id=6840b6df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6840b6df",
  null
  
)

export default component.exports